var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.2 122.9",
    style: {
      enableBackground: "new 0 0 107.2 122.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4,95.7H14.3v-92c0-2,1.6-3.7,3.7-3.7h28.7c2,0,3.7,1.6,3.7,3.7L50.4,95.7L50.4,95.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8,83H62c3.2,0,4.8,3.8,2.7,6.1l-29.3,32.6c-1.4,1.6-4,1.6-5.4,0L0,89.1C-2.1,86.8-0.4,83,2.8,83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5,43H99v48.1c0,2-1.6,3.7-3.7,3.7H83.1c-2,0-3.7-1.6-3.7-3.7V43H79.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,49.9H73.2c-1.7,0-2.6-2-1.5-3.3l15.9-17.7c0.8-0.9,2.1-0.9,2.9,0l16.2,17.7C107.9,47.8,107,49.9,105.3,49.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.fd12fe8e437130fb92a4e2db02e72d5a.svg";
export { ForwardRef as ReactComponent };